import React from 'react'

import Button from '@react/react-spectrum/Button'
import OverlayTrigger from '@react/react-spectrum/OverlayTrigger'
import Popover from '@react/react-spectrum/Popover'
import TooltipSpectrum from '@react/react-spectrum/Tooltip'

import InfoOutline from '@react/react-spectrum/Icon/InfoOutline'

export default function Tooltip({ content, footer, ...otherProps }) {
  if (!content) return

  return (
    <OverlayTrigger>
      <Button variant='tool' icon={<InfoOutline size='XS' />} style={{ margin: 0, height: '12px' }} {...otherProps} />
      {getTooltip(content, footer)}
    </OverlayTrigger>
  )
}

function getTooltip(tooltip, footer) {
  const isTooltipImage = tooltip.startsWith('http')
  const _tooltip = isTooltipImage ? <img src={tooltip} alt='tooltip' style={{ maxWidth: '500px' }} /> : tooltip
  if (isTooltipImage || footer) {
    return (
      <Popover>
        {_tooltip}
        {footer && <div style={{ margin: '1rem 0' }}>{footer}</div>}
      </Popover>
    )
  }

  return <TooltipSpectrum>{_tooltip}</TooltipSpectrum>
}
